module.exports = __webpack_public_path__ + "img/chrome.518b7ed1.png";